import { render, staticRenderFns } from "./AlertDetails.vue?vue&type=template&id=1d21ca01&scoped=true&"
import script from "./AlertDetails.vue?vue&type=script&lang=js&"
export * from "./AlertDetails.vue?vue&type=script&lang=js&"
import style0 from "./AlertDetails.vue?vue&type=style&index=0&id=1d21ca01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d21ca01",
  null
  
)

export default component.exports